﻿import React from 'react';

import DynamicFormHelpText from '../Components/DynamicFormHelpText';
import DynamicFormError from '../Components/DynamicFormError';

const Checkbox = ({ question, value, isValid, isTouched, invalidError, ...props }) => {
    const questionId = question.id;
    const questionText = question.questionText;
    const questionHelpText = question.helpText ? question.helpText : null;
    const isUneditable = question.isUneditable;

    return (
        <div className="dynamicFormCheckboxContainer">
            <label htmlFor={questionId}>
                {questionText}
                {questionHelpText &&
                    <DynamicFormHelpText questionGroupHelpText={questionHelpText} />
                }
            </label>
            <span className="dynamicFormCheckboxFauxLabel">{question.options[0].text}</span>
            <div className="dynamicFormCheckboxWrapper">
                <input
                    type="checkbox"
                    id={`question-${questionId}`}
                    key={questionId}
                    name={questionId}
                    value={question.options[0].text}
                    defaultChecked={value === question.options[0].text ? true : false}
                    disabled={isUneditable}
                    {...props}
                />
                <span className="dynamicFormCheckbox" />
            </div>
            {!isValid && typeof isValid !== 'undefined' && isTouched &&
                <DynamicFormError>
                    {invalidError}
                </DynamicFormError>
            }
        </div>
    );
};

export default Checkbox;
